import { Checkbox, Stack } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

import { MissingServicesFilterDrawerSectionProps } from "./types/missing-services";

/**
 * A checkbox section of the Filter Services drawer. Both sections it serves (Encounter, By Status)
 * have a fixed, locally-known option list, so it never loads anything — the Provider section, whose
 * options come from the server, is `MissingServicesFilterProviderSection` instead.
 */
export default function MissingServicesFilterDrawerSection({
  section,
  selectedKeys,
  onToggle,
}: MissingServicesFilterDrawerSectionProps) {
  return (
    <Stack gap="md" data-testid={`missing-services-filter-section-${section.id}`}>
      <TextWrapper size="md" c="dark.9" variant="bold">
        {section.title}
      </TextWrapper>
      {section.options.map((option) => (
        <Checkbox
          key={option.key}
          label={option.label}
          onChange={() => onToggle(option.key)}
          checked={selectedKeys.includes(option.key)}
          data-testid={`missing-services-filter-option-${section.id}-${option.key}`}
        />
      ))}
    </Stack>
  );
}
